import { queryOptions } from '@tanstack/react-query'
import { parseDate } from '../../../config/dayjsConfig'
import fiscalYearQueryKeys from './fiscalYearQueryKeys'
import { fetchFiscalYears } from '../service/fiscalYearService'
import { FiscalYear } from '../../../types/fiscalYear/FiscalYear'

export const useFiscalYearOptions = <TData = FiscalYear[]>(
  companyId: string,
  select?: (data: FiscalYear[]) => TData
) => {
  return queryOptions({
    queryKey: fiscalYearQueryKeys.list({ companyId }),
    queryFn: fetchFiscalYears,
    enabled: !!companyId,
    staleTime: 1000 * 60 * 60 * 4,
    select: data => {
      const sortedData = data.slice().sort((a, b) => {
        const dateA = parseDate(a.startDate)
        const dateB = parseDate(b.startDate)
        return (dateA?.valueOf() || 0) - (dateB?.valueOf() || 0)
      })
      return select ? select(sortedData) : (sortedData as TData)
    }
  })
}
